
export default function About() {
  return (
    <section className="py-20 bg-cream-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Stories that <span className="text-red-700">Matter</span>
              </h2>
              <div className="w-20 h-1 bg-red-700 mb-8"></div>
            </div>

            <p className="text-xl text-gray-700 leading-relaxed">
              Somukoi is a citizen journalism movement — a platform where stories of people, culture, and innovation come alive through real voices.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              From local heroes to traditional art revival, we document the heartbeat of the Northeast. Every story shared strengthens our cultural fabric and builds bridges between communities.
            </p>

            {/* Category Icons */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8">
              <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-group-line text-2xl text-red-700"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">People & Communities</h3>
                <p className="text-sm text-gray-600">Real stories from real people</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-palette-line text-2xl text-red-700"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Culture & Heritage</h3>
                <p className="text-sm text-gray-600">Preserving our rich traditions</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-2xl text-red-700"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Youth & Innovation</h3>
                <p className="text-sm text-gray-600">Tomorrow's leaders today</p>
              </div>
            </div>
          </div>

          {/* Visual Content */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Young%20Assamese%20woman%20in%20traditional%20mekhela%20chador%20sharing%20stories%20on%20smartphone%2C%20cultural%20festival%20background%2C%20warm%20lighting%2C%20authentic%20Northeast%20Indian%20cultural%20scene%20with%20traditional%20handloom%20patterns&width=300&height=400&seq=about-1&orientation=portrait"
                  alt="Cultural storytelling"
                  className="w-full h-64 object-cover rounded-xl shadow-lg"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Traditional%20Assamese%20bamboo%20craft%20artisan%20working%2C%20cultural%20heritage%20preservation%2C%20warm%20natural%20lighting%2C%20authentic%20Northeast%20Indian%20craftsmanship%20with%20traditional%20tools%20and%20patterns&width=300&height=300&seq=about-2&orientation=squarish"
                  alt="Traditional crafts"
                  className="w-full h-48 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=Northeast%20Indian%20youth%20innovation%20hub%2C%20young%20entrepreneurs%20working%20on%20technology%20projects%2C%20modern%20workspace%20with%20traditional%20cultural%20elements%2C%20inspiring%20innovation%20scene&width=300&height=300&seq=about-3&orientation=squarish"
                  alt="Youth innovation"
                  className="w-full h-48 object-cover rounded-xl shadow-lg"
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Assamese%20Bihu%20festival%20celebration%2C%20traditional%20dancers%20in%20colorful%20attire%2C%20cultural%20heritage%20celebration%2C%20vibrant%20community%20gathering%20with%20traditional%20music%20and%20dance&width=300&height=400&seq=about-4&orientation=portrait"
                  alt="Cultural festivals"
                  className="w-full h-64 object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-red-200 rounded-full opacity-60"></div>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-red-100 rounded-full opacity-80"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
